var map = {
	"./404.png": 6198,
	"./Group 1000004414.png": 9427,
	"./Group 1000004415.png": 2314,
	"./Group 1000004416.png": 1297,
	"./Icon (1).png": 3377,
	"./Icon (2).png": 1268,
	"./Icon.png": 2931,
	"./PdfLogo.png": 9389,
	"./Vector (1).png": 9099,
	"./Vector.png": 9309,
	"./all.svg": 3793,
	"./amount.svg": 1228,
	"./approvals.png": 8742,
	"./bills.jpg": 7712,
	"./calender.png": 5338,
	"./clock.svg": 1874,
	"./cross.svg": 9912,
	"./dahboardCalender.svg": 5135,
	"./dashboard-expense.svg": 5747,
	"./dashboardApprover.svg": 687,
	"./dashboardExpense.svg": 3728,
	"./dashboardPermission.svg": 9497,
	"./dashboardRoles.svg": 4503,
	"./dashboardStat.svg": 4290,
	"./dashboardUser.svg": 7093,
	"./delete.svg": 393,
	"./documentNormal.svg": 3954,
	"./down.svg": 9164,
	"./download.svg": 9248,
	"./dummyBill.png": 2937,
	"./editIcon.svg": 1919,
	"./expenses.png": 3823,
	"./graph.png": 8526,
	"./hamburg.svg": 8912,
	"./jpgIcon.svg": 8354,
	"./loading.svg": 7644,
	"./logo.png": 4485,
	"./logo.svg": 5941,
	"./new.svg": 7914,
	"./newLogo.svg": 5707,
	"./notification.svg": 7245,
	"./pdfIcon.svg": 4553,
	"./pendingApprovals.svg": 3603,
	"./pngIcon.svg": 9714,
	"./popupCross.svg": 238,
	"./sidebarCalendar.svg": 7222,
	"./sidebarCurrency.svg": 2709,
	"./sidebarDashboard.svg": 3608,
	"./sidebarDepartments.svg": 769,
	"./sidebarExpenseCode.svg": 4799,
	"./sidebarList.svg": 4796,
	"./sidebarNotification.svg": 4041,
	"./sidebarPendigRequest.svg": 3270,
	"./sidebarPermissions.svg": 3912,
	"./sidebarProjectCode.svg": 3328,
	"./sidebarRoles.svg": 4679,
	"./sidebarSettings.svg": 2819,
	"./sidebarUser.svg": 1045,
	"./unread.svg": 5781,
	"./upload.svg": 6507,
	"./uploadIcon.svg": 876,
	"./user.png": 6381
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7623;